import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaFadeRevealAnimation,
  paragraphRevealAnimation,
  type SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const imageTextRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const title = selector('[data-motion-title]')[0]
  const subtitle = selector('[data-motion-subtitle]')[0]
  const paragraph1 = selector('[data-motion-paragraph1]')[0]
  const paragraph2 = selector('[data-motion-paragraph2]')[0]
  const button = selector('[data-motion-button]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = mediaFadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0.1)
  }

  let subtitleAnimation: SharedAnimation
  if (subtitle) {
    subtitleAnimation = paragraphRevealAnimation(subtitle, reverse)
    timeline.add(subtitleAnimation.timeline, 0.1)
  }

  let paragraph1Animation: SharedAnimation
  if (paragraph1) {
    paragraph1Animation = fadeRevealAnimation(paragraph1)
    timeline.add(paragraph1Animation.timeline, 0.3)
  }

  let paragraph2Animation: SharedAnimation
  if (paragraph2) {
    paragraph2Animation = fadeRevealAnimation(paragraph2)
    timeline.add(paragraph2Animation.timeline, 0.4)
  }

  let buttonAnimation: SharedAnimation
  if (button) {
    buttonAnimation = fadeRevealAnimation(button)
    timeline.add(buttonAnimation.timeline, 0.5)
  }

  return () => {
    timeline.kill()

    mediaAnimation?.revert()
    titleAnimation?.revert()
    subtitleAnimation?.revert()
    paragraph1Animation?.revert()
    paragraph2Animation?.revert()
    buttonAnimation?.revert()
  }
}
